export enum BANNER_TYPE {
  DEFAULT = 'DEFAULT',
  FINAL_SALE = 'FINAL_SALE',
}
